import React, { useState } from 'react'
import styles from './index.module.scss'
import store from '@/store'
import { isMobiileFu } from '@/utils/history'

type props = {
  name: string
  isEn?: boolean
}
// name: tapian or xiantu
function QuanwenBtns({ name, isEn = false }: props) {
  const [currentActive, setCurrentActive] = useState(1)
  return (
    <div className={`${styles.tapianBtns} ${isEn ? styles.tapianBtnsEn : ''} ${isMobiileFu() && isEn ? styles.tapianBtnsEnMo : ''}`}>
      <div
        className={`btn songFont ${currentActive === 1 ? 'btnAc' : ''}`}
        onClick={() => {
          setCurrentActive(1)
          store.dispatch({
            type: 'layout/lookBigImg',
            payload: { url: require(`@/assets/img/A5_${name === 'tapian' ? 'tapian1.png' : 'xiantu1.png'}`), show: true, fromTxt: '', zoom: isMobiileFu() ? (name === 'tapian' ? 1.2 : 1.38) : 1 }
          })
        }}
      >
        {isEn ? 'Obverse of the Stele' : '碑阳'}
      </div>
      <div
        className={`btn songFont ${currentActive === 2 ? 'btnAc' : ''}`}
        onClick={() => {
          setCurrentActive(2)
          store.dispatch({
            type: 'layout/lookBigImg',
            payload: { url: require(`@/assets/img/A5_${name === 'tapian' ? 'tapian2.jpg' : 'xiantu2.png'}`), show: true, fromTxt: '', zoom: isMobiileFu() ? (name === 'tapian' ? 1.35 : 1.3) : 1 }
          })
        }}
      >
        {isEn ? 'The reverse back of the stele' : '碑阴'}
      </div>
      <div
        className={`btn songFont ${currentActive === 3 ? 'btnAc' : ''}`}
        onClick={() => {
          setCurrentActive(3)
          store.dispatch({
            type: 'layout/lookBigImg',
            payload: { url: require(`@/assets/img/A5_${name === 'tapian' ? 'tapian3.png' : 'xiantu3.png'}`), show: true, fromTxt: '', zoom: isMobiileFu() ? (name === 'tapian' ? 1.6 : 1.35) : 1 }
          })
        }}
      >
        {isEn ? 'The reverse side of the stele' : '碑侧'}
      </div>
    </div>
  )
}

const MemoQuanwenBtns = React.memo(QuanwenBtns)

export default MemoQuanwenBtns
